import { dummyInitialGraphData } from "../dummyData";
import {
  handleError,
  handleRequestError,
  hostUrl,
  jsonHeaders,
  message,
  plServerUrl,
  request,
  withResponseDummyFallback,
} from "./core";

export const shutdownPl = () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: plServerUrl("/users/stop/server"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then((response) =>
      withResponseDummyFallback(response, dummyInitialGraphData),
    )
    .catch((error) => handleRequestError(error, dummyInitialGraphData));
};

export const shutdownAll = async () => {
  const config = {
    method: "get",
    maxBodyLength: Infinity,
    url: hostUrl("/users/stop/server"),
    headers: jsonHeaders(),
  };
  return request(config)
    .then(() => {
      localStorage.removeItem("token");
      window.location.reload();
    })
    .catch((error) => {
      handleError(error);
      message.error(error?.response?.data?.message || "Server is Down");
    });
};
